import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-abfab650"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder-block placeholder-block--important details-panel-placeholder__title" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder-block details-panel-placeholder__grid" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "details-panel-placeholder__level-descriptions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelsDescriptionPlaceholder = _resolveComponent("LevelsDescriptionPlaceholder")!
  const _component_ContentPlaceholders = _resolveComponent("ContentPlaceholders")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createBlock(_component_PxPanel, { class: "details-panel-placeholder px-panel--mobile-no-side-borders" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ContentPlaceholders, {
        class: "details-panel-placeholder__container",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
              return _createVNode(_component_LevelsDescriptionPlaceholder, {
                key: i,
                class: "details-panel-placeholder__level-descriptions-entry"
              })
            }), 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}